import { NetworkResponse } from 'data-layer-cr/dist/network/NetworkTypes';
import { NaturalPersonEquifaxResponse } from 'src/models/responseTypes/NaturalPersonEquifaxResponse';
import processRequest from './processRequest';

// eslint-disable-next-line import/prefer-default-export
export const personRequest = async (
  id: string,
): Promise<NetworkResponse<NaturalPersonEquifaxResponse>> =>
  processRequest<NetworkResponse<NaturalPersonEquifaxResponse>>({
    method: 'GET',
    url: `/Person/personinformation?ruc=${id}`,
  });
